module.exports = ".Vermelho {\n    color: #f83636;\n    font-weight: bold;\n}\n.Amarelo {\n    color: #ef7d18;\n    font-weight: bold;\n}\n.Verde {\n    color: #3ca63c;\n    font-weight: bold;\n}\n.cursor-pointer {\n    cursor: pointer;\n}\n.advanced-search {\n     border-bottom: 1px solid #edf0f4;\n     margin: -0.5em 1.5em 1em 0;\n     padding-bottom: 1em;\n }\n\ntd span span {\n    color: inherit;\n}"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/manutencoes/manutencao-programada/manutencao-programada-list/manutencao-programada-list.component.css
 ** module id = 736
 ** module chunks = 0
 **/